import memoize from 'memoize-one';

import FeatureGates from '@atlaskit/feature-gate-js-client';

import {
	EDIT_PAGE_EXPERIENCE,
	LIVE_PAGE_EDIT_EXPERIENCE,
	LIVE_PAGE_VIEW_EXPERIENCE,
	VIEW_PAGE_EXPERIENCE,
} from './ExperienceName';

export const getLivePageViewExperienceName: () => string = memoize(() => {
	const isLivePageExpToCoreExpMigrationEnabled = FeatureGates.checkGate(
		'live_page_exp_to_core_exp_migration',
	);
	return isLivePageExpToCoreExpMigrationEnabled ? VIEW_PAGE_EXPERIENCE : LIVE_PAGE_VIEW_EXPERIENCE;
});

export const getLivePageEditExperienceName: () => string = memoize(() => {
	const isLivePageExpToCoreExpMigrationEnabled = FeatureGates.checkGate(
		'live_page_exp_to_core_exp_migration',
	);
	return isLivePageExpToCoreExpMigrationEnabled ? EDIT_PAGE_EXPERIENCE : LIVE_PAGE_EDIT_EXPERIENCE;
});
